import * as swcHelpers from '@swc/helpers';
import { Types } from '@grandvisionhq/graphql';
import { getEyeSide } from '../../../utils/get-eye-side.js';
import { toBaseLineItem } from './base-line-item.js';
import { getContactLensA11yLabel } from './utils/get-product-a11y-label.js';
import { getAttribute } from '../../../utils/get-line-item-attribute.js';
import { getLocalizedAttribute } from '../../../utils/get-line-item-localized-attribute.js';
import { getProductTitle } from './utils/get-product-title.js';
import { getLineItemImageUrl } from '../../../utils/get-line-item-image-url.js';

const toEyeSideLabelKey = (eyeSide)=>{
    switch(eyeSide.toUpperCase()){
        case Types.EyeSide.LEFT:
            return 'products.contactLenses.leftEye';
        case Types.EyeSide.RIGHT:
            return 'products.contactLenses.rightEye';
        default:
            return 'products.contactLenses.both';
    }
};
const toEyeSide = (eyeSide)=>{
    switch(eyeSide){
        case 'left':
            return 'left';
        case 'right':
            return 'right';
        default:
            return 'both';
    }
};
const toEyePrescription = (variant)=>{
    const dominanceAttr = getAttribute(variant, 'dominance');
    const dominance = Types.Dominance[dominanceAttr] || null;
    return {
        addition: getAttribute(variant, 'addition') || null,
        axis: getAttribute(variant, 'axis') || null,
        baseCurve: getAttribute(variant, 'baseCurve') || null,
        cylinder: getAttribute(variant, 'cylinder') || null,
        power: getAttribute(variant, 'power') || null,
        diameter: getAttribute(variant, 'diameter') || null,
        dominance
    };
};
const toContactLensesCartLineItem = (cartLineItem, intl, settings)=>{
    const variant = cartLineItem.legacyProduct.masterData.current.variant;
    var ref;
    const eyeSide = toEyeSide((ref = getEyeSide(cartLineItem.typeDetails)) !== null && ref !== void 0 ? ref : 'left');
    const packageQuantity = getAttribute(variant, 'packageQuantity');
    const replacementFrequency = getLocalizedAttribute(variant, 'replacementFrequency', intl.locale);
    const eyeSideLabelKey = toEyeSideLabelKey(eyeSide || 'left');
    const prescription = toEyePrescription(variant);
    const title = getProductTitle(cartLineItem.legacyProduct, intl);
    return swcHelpers.objectSpread({}, toBaseLineItem(cartLineItem, settings, intl), {
        productType: 'contact-lenses',
        title,
        eyeSide,
        prescription,
        type: 'CONTACT_LENSES',
        subtitle: `${intl.getLabel(eyeSideLabelKey)}, ${packageQuantity} ${replacementFrequency} ${intl.getLabel('products.unit.contactLenses')}`,
        imageUrl: getLineItemImageUrl(variant, settings.staticsUrl, settings.isBynderImagesEnabled),
        altText: prescription ? getContactLensA11yLabel(prescription, eyeSide, intl, title) : title
    });
};

export { toContactLensesCartLineItem, toEyePrescription };
//# sourceMappingURL=contact-lenses-line-item.js.map
